import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'

export function useUserRole(): 'Planner' | 'Member' | null {
  const { data } = useQuery({
    queryKey: ['auth', 'session'],
    queryFn: () => supabase.auth.getSession().then(({ data: { session } }) => session),
    staleTime: Infinity,
  })

  // DEBUG: remove after diagnosing role issue
  console.log('[useUserRole] query data:', data ? { hasAccessToken: !!data.access_token } : data)

  if (!data?.access_token) return null

  try {
    const b64 = data.access_token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')
    const payload = JSON.parse(atob(b64))
    const role = (payload.user_role ?? payload.role) as string | undefined
    // DEBUG: remove after diagnosing role issue
    console.log('[useUserRole] JWT payload role:', payload.role, 'user_role:', payload.user_role, 'resolved:', role)
    if (role === 'Planner' || role === 'Member') return role
    return null
  } catch {
    return null
  }
}
